import BaseLayout from '@/layouts/BaseLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

export const LAYOUT = BaseLayout
export { EmptyLayout }

/** 首页 */
export const HOME_PATH = '/home'
